# WHERE "HOME" IS — card 6ac022cba664bc34d57be8c7 (owner design 2026-10-02).
#
# The landing screen used to be decided in several places, each sending people
# straight to the built-in 'dashboard': the boot's post-login routing, the
# router's fallback, the title bar's Dashboard button and logo, the student
# avatars in the drawer, the exits from the game screens, and the sign-in
# screen. They all ask here now, so that a mobile device lands on — and RETURNS
# to — the mobile App's dashboard, and every other device lands where it always
# did.
#
# The mobile dashboard is the FIRST entry of the hosted mobile App's manifest
# (app-route.coffee sets window.app.hostedRoutes, in manifest order, only on a
# mobile device that hosts a row). Nothing hosted: 'dashboard', unchanged. This
# is also what every shell but /app gets, since only /app hosts.
#
# A route name, so callers keep their own params (studentId).
#
# IMPORT-FREE ON PURPOSE: a pin drives it with a stub app.
export landingRoute = (app = window?.app) ->
  hosted = app?.hostedRoutes
  if hosted?.length then hosted[0] else 'dashboard'

# Is this route name the landing screen of either kind? The boot asks this of
# a deep link's target: a link to the dashboard on a mobile device opens the
# mobile dashboard.
export isLandingName = (name, app = window?.app) ->
  name is 'dashboard' or name is landingRoute(app)
